// extracted by mini-css-extract-plugin
module.exports = {"container":"_1j0_4","forumContainer":"ZANaS","divider":"_2EfWL"};